<template>
  <nav class="main-header__nav">
    <div
      class="main-header__nav__overlay main-header__nav__overlay--clear"
      @click="onClose"
    ></div>
    <div class="main-header__nav__container">
      <div class="main-header__nav-top">
        <span class="main-header__offcanvas__close" @click="onClose"></span>
        <app-locale-switcher
          class="locale-switcher"
          :value="locale"
          :active-lang-menu="activeLang"
          @input="onLocaleChange"
          @langShowMenu="toggleLangMenu"
        />
      </div>
      <app-mega-menu
        :items="megaMenuItems"
        :active-dropdown="activeDropdown"
        @close="onSubMenuClose"
        @open="onSubMenuOpen"
      />
    </div>
  </nav>
</template>

<script>
import AppMegaMenu from "@/components/layout/header/MegaMenu";
import AppLocaleSwitcher from "@/components/layout/header/LocaleSwitcher";
import AppWebsiteLink from "@/components/ui/WebsiteLink";

export default {
  name: "AppMenu",
  props: {
    megaMenuItems: {
      type: Array,
      required: true,
      default: () => [],
    },
    locale: {
      type: String,
      required: true,
    },
    activeLang: {
      type: Boolean,
      required: true,
    },
    activeDropdown: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    AppLocaleSwitcher,
    AppMegaMenu,
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    onSubMenuClose() {
      this.$emit("closeSubMenu");
    },
    onSubMenuOpen() {
      this.$emit("openSubMenu");
    },
    toggleLangMenu() {
      this.$emit("langShow");
    },
    onLocaleChange(locale) {
      this.$emit("localeChange", locale);
    },
  },
};
</script>
